<template>
  <v-card class="request-list-card">
    <v-card-title>
      <h3>{{ title }}</h3>
      <v-btn v-if="create" flat icon absolute right :to="create">
        <v-icon color="success">add</v-icon>
      </v-btn>
    </v-card-title>
    <v-list>
      <v-list-tile v-for="(item, i) in items" :key="i"
                   :to="`/approvals/requests/${item.userId}/${item.createdTs}`">
        <v-list-tile-action v-if="item.status">
          <v-icon :color="item.status" small>fiber_manual_record</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ item.user }}
          </v-list-tile-title>
          <v-list-tile-sub-title>
            <i>{{ item.scopes }}</i>
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <div class="link-container">
      <v-btn flat small @click="goToList">View all</v-btn>
    </div>
  </v-card>
</template>

<script>
  export default {
    props: {
      title: {
        type: String
      },
      create: {
        type: String,
        default: null
      },
      items: {
        type: Array
      }
    },
    methods: {
      goToList() {
        this.$emit('view');
      }
    }
  };
</script>

<style scoped lang="less">
  @import "../../style/variables.less";

  .request-list-card {
    margin: 5px;

    .request-list-title {
      margin: 0;
    }

    h3 {
      margin: auto;
      width: 100%;
    }

    .half-width {
      width: 50%;
    }

    .space-left {
      margin-left: 0.4em;
    }

    .link-container {
      text-align: right;
      padding-bottom: 5px;
      padding-right: 15px;
    }
  }
</style>
